import '@/assets/css/nprogress.css'
import NProgress from 'nprogress';

/**
 * NProgress configuration
 * @link https://github.com/rstacruz/nprogress#configuration
 */
NProgress.configure({
  showSpinner: false,
  parent: '#app',
})

export default {
  install(app) {
    app.config.globalProperties.$NProgress = NProgress;
  },
};
